import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { Proof } from '../../../../models/Proof';
import { ProofService } from '../../../../services/proof.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, NgClass, NgForOf, NgIf, CommonModule } from '@angular/common';
import { GenericFormComponent } from '../../../../shared/components/generic-crud/generic-form/generic-form.component';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';
import { Card, CardState } from '../../../../models/Card';
import { GenericCrudService } from '../../../../services/generic-crud.service';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';

@Component({
  selector: 'app-proof-details',
  standalone: true,
  imports: [GenericCrudComponent, NgForOf, NgClass, NgIf, GenericFormComponent, DatePipe, CommonModule, FormsModule, ModalComponent],
  templateUrl: './proof-details.component.html',
  styleUrl: './proof-details.component.css'
})
export class ProofDetailsComponent implements AfterViewInit {
  @ViewChild('alumnosCrud', { read: ElementRef }) alumnosCrud!: ElementRef;
  proof!: Proof;

  proofForm!: GenericForm;

  today: Date = new Date();

  activeProofForm: boolean = false;
  activeAlumnoForm: boolean = false;
  allowOpenModal: boolean = false;

  activeTab: 'students' | 'dgt-procedures' = 'students';
  isPresenting: boolean = false;
  presentationErrors: any[] = [];
  showPresentationErrorsModal: boolean = false;


  // Sistema de tarjetas DGT
  cards: Card[] = [];
  selectedCards: Set<number> = new Set();
  isLoadingCards: boolean = false;
  isUpdatingStatus: boolean = false;

  tableColumns: GenericTableColumn[] = [
    { name: 'Alumno', active: true, type: 'text', key: 'user.name', sort: true },
    { name: 'Producto', active: true, type: 'text', key: 'product.name', sort: false },
    { name: 'Centro Oficial', active: true, type: 'text', key: 'official_center.centerName', sort: false },
    { name: 'Estado Examen', active: true, type: 'badge', key: 'exam_status', sort: false, labelMap: { 'inscrito': 'Inscrito', 'presentado': 'Presentado', 'evaluado': 'Evaluado' }, colorMap: { 'inscrito': 'bg-blue-100 text-blue-800', 'presentado': 'bg-purple-100 text-purple-800', 'evaluado': 'bg-green-100 text-green-800' } },
    { name: 'Fecha y Hora de Cita', active: true, type: 'date-time', key: 'appointment_date_time_site', sort: false },
    { name: 'Calificación', active: true, type: 'text', key: 'qualification.name', sort: false },
    { name: 'Examinador', active: true, type: 'text', key: 'examiner.name', sort: true },
    { name: 'Estado', active: false, type: 'badge', key: 'status', sort: false, labelMap: { 'active': 'Activo', 'moved': 'Movido' }, colorMap: { 'active': 'bg-green-100 text-green-800', 'moved': 'bg-yellow-100 text-yellow-800' } },
    { name: 'Movido a', active: false, type: 'text', key: 'moved_to_proof_name', sort: false },
    { name: 'Comentarios', active: true, type: 'custom', key: 'add-comment-button', sort: false },
  ];

  proofFormFields: GenericFormField[] = [];

  formFieldsEdit: GenericFormField[] = [
    { name: 'user_id', type: 'select', label: 'Alumno', validations: 'required', url: '/user/students', singleSelection: true },
    { name: 'official_center_id', type: 'select', label: 'Centro Oficial', validations: 'nullable', url: '/config/official-center/listAll', singleSelection: true },
    { name: 'appointment_date_time_site', type: 'dateTime', label: 'Fecha y Hora de Cita', validations: 'nullable' },
    { name: 'qualification_id', type: 'select', label: 'Calificación', validations: 'nullable', url: '/config/qualification/list', singleSelection: true },
    { name: 'examiner_id', type: 'select', label: 'Examinador', validations: 'nullable', url: '/config/examiner/listAll', singleSelection: true, showIf: () => this.showExaminerField() }
  ];

  proofFormFieldsEdit: GenericFormField[] = [
    { name: 'proof_definitions', type: 'select', label: 'Exámenes', validations: 'required', url: '/config/proof-definition/listAll', singleSelection: false },
    { name: 'proof_center_id', type: 'select', label: 'Centro de Examen', validations: 'nullable', url: '/config/proof-center/listAll', singleSelection: true },
    { name: 'registration_deadline', type: 'date', label: 'Limite Inscripcion', validations: 'required' },
    { name: 'date', type: 'date', label: 'Fecha', validations: 'required', singleSelection: true },
    { name: 'time', type: 'time', label: 'Hora', validations: 'required', singleSelection: true },
  ];

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Asignación de alumno actualizada correctamente',
        errorTitle: 'Error al actualizar la asignación',
        fields: this.formFieldsEdit,
        name: 'asignación',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/proofs-users/update/{{proof_id}}/{{user_id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar asignación de {{user_name}}',
        formTitle: '',
        formButtonTitle: 'Actualizar',
        width: '2xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7h-1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"/><path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97l-8.415 8.385v3h3l8.385-8.415z"/><path d="M16 5l3 3"/></svg>`,
      confirmation: false
    },
    {
      name: 'Mover',
      key: 'move',
      form: {
        method: 'POST',
        successTitle: 'Alumno movido correctamente',
        errorTitle: 'Error al mover el alumno',
        fields: [
          { name: 'target_proof_id', type: 'select', label: 'Convocatoria destino', validations: 'required', url: '/proof/listAll', singleSelection: true }
        ],
        name: 'mover alumno',
        createButtonTitle: '',
        cols: 1,
        createApiSlug: '',
        originalCreateApiSlug: '/proofs-users/move/{{proof_id}}/{{user_id}}',
        originalFormTitle: 'Mover {{user_name}} a otra convocatoria',
        formTitle: '',
        formButtonTitle: 'Mover',
        width: 'xl'
      },
      completeForm: false,
      deleteRowOnResponse: true,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>`,
      confirmation: false,
      showIf: (item: any) => item.status !== 'moved'
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>`,
      confirmation: true,
      questionText: '¿Desea eliminar este alumno de la prueba?',
      deleteRowOnResponse: true,
      actionSlug: '/proofs-users/delete/{{proof_id}}/{{user_id}}',
      showIf: (item: any) => item.status !== 'moved'
    }
  ];

  table!: GenericTable<Paginator<any>>;

  filters: Filter[] = [
    { type: 'search', key: 'user.name', operator: 'like', placeholder: 'Buscar alumno' }
  ];

  genericCRUD: GenericCRUD<Paginator<any>> = {
    genericForm: {
      successTitle: '',
      errorTitle: '',
      method: '',
      fields: [],
      name: '',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      formTitle: '',
      formButtonTitle: '',
      width: 'sm'
    },
    genericTable: {
      columns: [],
      items: [],
      type: 'generic',
      loadItemsSlug: '',
      paginate: true,
      name: '',
      actions: [],
      details: false
    },
    genericFilters: [],
    useModalForm: true
  };

  alumnoForm!: GenericForm;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private proofService: ProofService,
    private breadcrumbService: BreadcrumbService,
    private genericCrudService: GenericCrudService,
    private toastr: ToastrService
  ) {
    const navItem = this.router.getCurrentNavigation()?.extras?.state?.['item'];
    const proofId = this.route.snapshot.paramMap.get('id');
    if (navItem && proofId) {
      const name = navItem.generated_name || navItem.name;
      if (name) {
        this.breadcrumbService.setBreadcrumb({
          display_name: name,
          url: `/dashboard/pruebas/${proofId}`,
          items: [
            { name: 'Convocatoria de Exámenes', url: '/dashboard/pruebas' },
            { name, url: `/dashboard/pruebas/${proofId}` }
          ]
        });
      }
    }
    if (proofId) {
      this.proofService.get(+proofId).subscribe({
        next: response => {
          if (response.data) {
            this.proof = response.data;
            this.breadcrumbService.setBreadcrumb({
              display_name: this.proof.generated_name || 'Examen',
              url: `/dashboard/pruebas/${proofId}`,
              items: [
                { name: 'Convocatoria de Exámenes', url: '/dashboard/pruebas' },
                { name: this.proof.generated_name || 'Examen', url: `/dashboard/pruebas/${proofId}` }
              ]
            });
          }
        },
        error: err => {
          console.log(err);
        },
        complete: () => {
          // Construir proofFormFields con el proof_id
          this.proofFormFields = [
            {
              name: 'license_id',
              type: 'select',
              label: 'Carnet',
              validations: 'required',
              url: '/config/license/listAll',
              singleSelection: true,
              onValueChange: (value: any) => {
                const licenseId = value?.id || value;
                const userField = this.proofFormFields.find(f => f.name === 'user_ids');
                if (userField && licenseId) {
                  userField.url = `/user/students?proof_id=${this.proof.id}&license_id=${licenseId}`;
                  return { _reloadFields: ['user_ids'] };
                }
                return {};
              }
            },
            { name: 'appointment_date_time_site', type: 'dateTime', label: 'Fecha y Hora de Cita', validations: 'nullable' },
            {
              name: 'user_ids',
              type: 'select',
              label: 'Alumnos',
              validations: 'required',
              url: `/user/students?proof_id=${this.proof.id}`,
              singleSelection: false
            },
            { name: 'official_center_id', type: 'select', label: 'Centro Oficial', validations: 'nullable', url: '/config/official-center/listAll', singleSelection: true },
            { name: 'qualification_id', type: 'select', label: 'Calificación', validations: 'nullable', url: '/config/qualification/list', singleSelection: true },
            {
              name: 'examiner_id',
              type: 'select',
              label: 'Examinador',
              validations: 'nullable',
              url: '/config/examiner/listAll',
              singleSelection: true,
              showIf: () => this.showExaminerField()
            }
          ];

          this.proofForm = {
            method: 'PUT',
            successTitle: 'Edición correcta',
            errorTitle: 'Error en la edición',
            fields: this.proofFormFieldsEdit,
            name: 'prueba',
            createButtonTitle: '',
            cols: 2,
            createApiSlug: '',
            updateApiSlug: '/proof/update/' + (this.proof ? this.proof.id : ''),
            formTitle: this.proof.generated_name
              ? 'Editar ' + this.proof.generated_name
              : 'Editar Prueba',
            formButtonTitle: 'Editar',
            width: '3xl'
          };

          // Activar columnas de estado/movido si hay alumnos movidos
          if ((this.proof as any).has_moved_students) {
            this.tableColumns = this.tableColumns.map(col => {
              if (col.key === 'status' || col.key === 'moved_to_proof_name') {
                return { ...col, active: true };
              }
              return col;
            });
          }

          this.table = {
            columns: this.tableColumns,
            items: [],
            type: 'generic',
            loadItemsSlug: '/proofs-users/index/' + (this.proof ? this.proof.id : '') + '?show_moved=1',
            paginate: true,
            name: 'asignaciones',
            actions: this.tableActions,
            details: false,
            bulkActions: [
              {
                name: 'APTO',
                key: 'bulk-apto',
                icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>`,
                actionSlug: `/proofs-users/bulk-qualify/${this.proof.id}/1`,
                method: 'POST',
                confirmation: true,
                questionText: '¿Calificar a los alumnos seleccionados como APTO?',
              },
              {
                name: 'NO APTO',
                key: 'bulk-no-apto',
                icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`,
                actionSlug: `/proofs-users/bulk-qualify/${this.proof.id}/2`,
                method: 'POST',
                confirmation: true,
                questionText: '¿Calificar a los alumnos seleccionados como NO APTO?',
              }
            ]
          };

          this.alumnoForm = {
            successTitle: 'Alumno asignado correctamente',
            errorTitle: 'Error al asignar alumno',
            method: 'POST',
            fields: this.proofFormFields,
            name: 'asignación',
            createButtonTitle: 'Nuevo Alumno',
            cols: 2,
            createApiSlug: '/proofs-users/store/' + (this.proof ? this.proof.id : ''),
            formTitle: 'Asignar Alumno',
            formButtonTitle: 'Guardar',
            width: '2xl'
          };

          this.genericCRUD = {
            genericForm: this.alumnoForm,
            genericTable: this.table,
            useModalForm: true
          };
        }
      });
    }
  }

  showExaminerField(): boolean {
    if (!this.proof?.proof_definitions?.length) {
      return false;
    }
    return this.proof.proof_definitions.some(d => d.type === 'Abierto' || d.type === 'Cerrado');
  }

  toggleActiveProofForm() {
    this.activeProofForm = !this.activeProofForm;
  }

  ngAfterViewInit() {
    // Interceptar el botón del CRUD después de que se renderice
    setTimeout(() => {
      const button = this.alumnosCrud?.nativeElement?.querySelector('button');
      if (button) {
        button.addEventListener('click', (event: Event) => {
          if (!this.allowOpenModal) {
            event.preventDefault();
            event.stopPropagation();
            this.checkAndOpenForm();
          }
        }, { capture: true });
      }
    }, 100);
  }

  checkAndOpenForm() {
    this.proofService.checkAvailableStudents(this.proof.id).subscribe({
      next: (response: any) => {
        if (response.success && response.data && response.data.length === 0) {
          this.toastr.warning(
            'No hay alumnos disponibles para asignar. Todos los alumnos con el producto correspondiente ya están inscritos en este examen.',
            'Sin alumnos disponibles',
            { timeOut: 5000 }
          );
        } else {
          // Permitir abrir el modal
          this.allowOpenModal = true;
          const button = this.alumnosCrud?.nativeElement?.querySelector('button');
          if (button) {
            button.click();
          }
          // Resetear la bandera después
          setTimeout(() => this.allowOpenModal = false, 100);
        }
      },
      error: () => {
        // Si hay error, abrir de todas formas
        this.allowOpenModal = true;
        const button = this.alumnosCrud?.nativeElement?.querySelector('button');
        if (button) {
          button.click();
        }
        setTimeout(() => this.allowOpenModal = false, 100);
      }
    });
  }

  onFinishProofForm() {
    this.toggleActiveProofForm();
    if (this.proof) {
      this.proofService.get(this.proof.id).subscribe({
        next: response => {
          if (response.data) {
            this.proof = response.data;
          }
        }
      })
    }
  }

  parseDateFromString(dateStr: string): Date {
    const parsedDate = new Date(dateStr);

    // Verifica si la fecha es válida
    return parsedDate;
  }

  setActiveTab(tab: 'students' | 'dgt-procedures') {
    this.activeTab = tab;
    if (tab === 'dgt-procedures' && this.cards.length === 0) {
      this.loadCards();
    }
  }

  loadCards() {
    if (!this.proof?.id) return;
    
    this.isLoadingCards = true;
    this.genericCrudService.list('/cards?proof_id=' + this.proof.id, []).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.cards = Array.isArray(response.data) ? response.data : response.data.data || [];
        }
        this.isLoadingCards = false;
      },
      error: (error) => {
        console.error('Error loading cards:', error);
        this.isLoadingCards = false;
      }
    });
  }

  toggleCardSelection(cardId: number) {
    if (this.selectedCards.has(cardId)) {
      this.selectedCards.delete(cardId);
    } else {
      this.selectedCards.add(cardId);
    }
  }

  toggleSelectAll() {
    if (this.selectedCards.size === this.cards.length) {
      this.selectedCards.clear();
    } else {
      this.cards.forEach(card => this.selectedCards.add(card.id));
    }
  }

  get allSelected(): boolean {
    return this.cards.length > 0 && this.selectedCards.size === this.cards.length;
  }

  bulkChangeState(state: string) {
    if (this.selectedCards.size === 0) return;

    this.isUpdatingStatus = true;
    const cardIds = Array.from(this.selectedCards);

    this.genericCrudService.reqByMethod('/cards/bulk-change-state', 'POST', {
      card_ids: cardIds,
      state: state,
      reason: `Cambio masivo a estado ${state}`
    }).subscribe({
      next: (response) => {
        if (response.success) {
          this.loadCards();
          this.selectedCards.clear();
        }
        this.isUpdatingStatus = false;
      },
      error: (error) => {
        console.error('Error changing card states:', error);
        this.isUpdatingStatus = false;
      }
    });
  }

  presentProof() {
    if (!this.proof?.id || this.isPresenting) return;

    this.isPresenting = true;
    this.genericCrudService.reqByMethod('/proofs-users/present/' + this.proof.id, 'POST', {}).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.toastr.success(response.message, 'Presentación exitosa');
          // Refrescar tabla
          this.genericCRUD = { ...this.genericCRUD, genericTable: { ...this.table } };
        } else {
          // Mostrar errores de validación
          const errors = response.data?.errors || [];
          if (errors.length > 0) {
            this.presentationErrors = errors;
            this.showPresentationErrorsModal = true;
          } else {
            this.toastr.error(response.message || 'Error', 'Error');
          }
        }
        this.isPresenting = false;
      },
      error: (error: any) => {
        this.toastr.error(error.error?.message || 'Error al presentar', 'Error');
        this.isPresenting = false;
      }
    });
  }

  bulkRequestCards() {
    this.bulkChangeState('SOLICITADA');
  }

  bulkMarkAsReceived() {
    this.bulkChangeState('RECIBIDA EN AUTOESCUELA');
  }

  bulkMarkAsDelivered() {
    this.bulkChangeState('ENTREGADA');
  }

}
